<template>
  <div>
    <section>
      <b-sidebar
        type="is-light"
        :fullheight="true"
        v-model="open"
        id="sidebar-menu"
      >
        <div class="p-1">
          <div style="text-align: center">
            <img style="height: 4rem" src="/opc_2_color.png" />
          </div>

          <b-menu>
            <b-menu-list label="Menu">
              <multiselect
                v-if="
                  cargosActivos != null &&
                  cargosActivos.length > 0 &&
                  cargoActivoSeleccionado != null
                "
                v-model="cargoActivoSeleccionado"
                :options="cargosActivos.map((type) => type.id)"
                :custom-label="
                  (opt) => cargosActivos.find((x) => x.id === opt).name
                "
                @input="changeActiveProfile"
                placeholder=""
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                :allow-empty="false"
              >
                <template v-slot:noOptions> No existen datos </template>
              </multiselect>

              <b-menu-item
                href="/performance_phases"
                v-if="isAuthorized('ManagePerformances')"
                icon="cogs"
                label="Administración Procesos de la Evaluación Académica"
              />
              <b-menu-item
                href="/performance_phases/faculty"
                v-if="isAuthorized('PerformancesFaculty')"
                icon="user-clock"
                label="Procesos de la Evaluación Académica"
              />
              <b-menu-item
                href="performances/manage-performance-participants"
                v-if="isAuthorized('ManagePerformancesParticipants')"
                icon="users-cog"
                label="Gestión de participantes del proceso"
              />

              <b-menu-item
                :href="'/admin/units/' + unit"
                v-if="
                  isAuthorized('UnitShow') &&
                  nombreCargoActivo.includes('DIR DEPTO')
                "
                icon="user-clock"
                label="Procesos de la Evaluación Académica"
              />

              <b-menu-item
                href="/performances/declare"
                v-if="nombreCargoActivo === 'ACADEMICO'"
                icon="tasks"
                label="Acceder a Evaluación Académica Actual"
              />

              <b-menu-item
                :href="'/people/' + personId"
                v-if="
                  isAuthorized('PersonShow') &&
                  nombreCargoActivo === 'ACADEMICO'
                "
                icon="book"
                label="Mis Evaluaciones Académicas"
              />
            </b-menu-list>
          </b-menu>
        </div>
        <footer class="footer" id="sidebar-footer">
          <b-menu-list label="Ayuda">
            <b-menu-item
              @click="showModal = true"
              icon="address-book"
              label="Contacto"
            ></b-menu-item>
          </b-menu-list>
        </footer>
      </b-sidebar>

      <b-button
        class="is primary is-small"
        @click="open = true"
        icon-left="bars"
      ></b-button>
      <b-loading
        :is-full-page="true"
        v-model="isLoading"
        :can-cancel="false"
      ></b-loading>
      <b-modal
        v-model="showModal"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-modal
      >
        <template #default="props">
          <contact-modal @close="props.close"></contact-modal>
        </template>
      </b-modal>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import ContactModal from "./contact_modal.vue";
export default {
  components: {
    ContactModal,
  },
  data() {
    return {
      open: false,
      isLoading: false,
      cargoActivoSeleccionado: null,
      showModal: false,
    };
  },
  created() {
    this.isLoading = true;
    if (this.cargosActivos != null && this.cargosActivos.length == 1) {
      this.cargoActivoSeleccionado = this.cargosActivos[0].id;
    } else {
      this.cargoActivoSeleccionado = this.cargoActivo;
    }
    this.isLoading = false;
  },
  props: [
    "userId",
    "permisos",
    "personId",
    "cargosActivos",
    "cargoActivo",
    "unidadActiva",
    "unit",
    "nombreCargoActivo",
  ],
  methods: {
    isAuthorized(nombre) {
      var objeto = this.permisos.find((obj) => obj.nombre === nombre);
      if (objeto !== undefined) {
        return objeto.value;
      } else {
        return false;
      }
    },
    isDataAuthorized() {
      return !!(
        this.isAuthorized("Project") ||
        this.isAuthorized("Publication") ||
        this.isAuthorized("Product") ||
        this.isAuthorized("Patent") ||
        this.isAuthorized("Disclosure") ||
        this.isAuthorized("Book")
      );
    },
    isDataSdtAuthorized() {
      return !!(
        this.isAuthorized("AddSdtService") ||
        this.isAuthorized("SdtServices") ||
        this.isAuthorized("UnitSdt") ||
        this.isAuthorized("MasiveUploadSdt")
      );
    },
    isDataSdtTransactionAuthorized() {
      return !!(
        this.isAuthorized("AddTransactionsSdt") ||
        this.isAuthorized("IndexTransactionsSdt") ||
        this.isAuthorized("ReportingTransactionsSdt")
      );
    },
    toMyData() {
      return "/people/" + this.personId;
    },
    toMyValidations() {
      return "/validations/user/" + this.userId;
    },
    toMyUnitValidation() {
      return "/validations/my-unit/";
    },
    toMyUnit() {
      return "/admin/units/" + this.unidadActiva;
    },
    toMySdtUnit() {
      return "/units/sdt/" + this.unidadActiva;
    },
    toReportsSdt() {
      return "/sdt_transactions/reporting/" + this.unidadActiva;
    },
    toMyLifeRecord() {
      return "/people/" + this.personId + "/my-life-record";
    },
    toMyAcademicData() {
      return "/people/" + this.personId + "/my-academic-data";
    },
    toMyOrcidSearch() {
      return "/people/" + this.personId + "/active-search/orcid";
    },
    addAcademicActivityAuthorized() {
      return !!(
        this.isAuthorized("AddProject") ||
        this.isAuthorized("AddPublication") ||
        this.isAuthorized("AddProduct") ||
        this.isAuthorized("AddPatent") ||
        this.isAuthorized("AddDisclosure") ||
        this.isAuthorized("AddBook") ||
        this.isAuthorized("AddInbook")
      );
    },
    changeActiveProfile() {
      this.isLoading = true;
      axios
        .post("/users/" + this.userId + "/change-profile", {
          active_profile: this.cargoActivoSeleccionado,
        })
        .then(async (response) => {
          await window.location.reload(false);
          //window.location.href = "/#"
          this.isLoading = false;
        })
        .catch((error) => {
          var elmnt = document.getElementById("app");
          elmnt.scrollIntoView();
          this.isLoading = false;
        });
    },
  },
  computed: {},
};
</script>
